import React, { Component } from "react"

import { CCard, CCardBody, CCardTitle } from "@coreui/react"
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye"

import { db } from "../../firebase/firebase_config"
import { getDocs, query, collection, where } from "firebase/firestore"

export class UserEntrenosData extends Component {
	constructor(props) {
		super(props)
		this.state = { dataReady: false, entrenos: null }
	}
	async getRegisters() {
		try {
			const registerCol = collection(db, "Register")
			const q = query(
				registerCol,
				where("participants", "array-contains", this.props.user.displayName)
			)
			const q_snapshot = await getDocs(q)
			var user_registered_trainings = []
			//console.log(q_snapshot)
			q_snapshot.forEach((doc) => {
				//console.log("User exists doc id: " + doc.id)
				//console.log("User exists: " + doc.data().displayName)
				//console.log(doc.data())
				user_registered_trainings.push(doc.id)
			})
			return user_registered_trainings
		} catch (error) {
			console.log(
				"Error retrieving user profile from firestore: ",
				error.message
			)
		}
	}
	async componentDidMount() {
		if (this.props.user) {
			const entrenos_ret = await this.getRegisters()
			this.setState({ entrenos: entrenos_ret, dataReady: true })
		}
	}

	render() {
		var num_entrenos = 0
		if (this.state.dataReady) num_entrenos = this.state.entrenos.length
		else num_entrenos = 0
		return (
			<CCard>
				<CCardBody>
					<CCardTitle>Entrenamientos</CCardTitle>

					<Stack direction="row" spacing={2}>
						<FitnessCenterIcon fontSize="small" />
						<Typography variant="body2" color="text.secondary">
							Entrenos: {num_entrenos ? num_entrenos : "-"}
						</Typography>
					</Stack>
				</CCardBody>
				<Button
					variant="text"
					endIcon={<RemoveRedEyeIcon size="small" />}
					disabled
				>
					Details
				</Button>
			</CCard>
		)
	}
}

export default UserEntrenosData
